export default {
  faq: "faq".toUpperCase(),
};
